import { z } from "zod";

export const approveMemberSchema = z
	.object({
		member_id: z.uuid(),
		action: z.enum(["approve", "reject"]),
	})
	.strict();

export type ApproveMemberPayload = z.infer<typeof approveMemberSchema>;
